import BaseError from '@errors/BaseError';

export default class ServerError extends BaseError {
    public status: number;

    public constructor(message: string) {
        super(message);
        this.name = 'ServerError';
    }
}
